module.exports = __webpack_public_path__ + "static/media/OOPSIN.d4f01260.png";